import React, { useMemo, useRef, useState } from 'react'
import { useAxios } from 'zhooks/useAxios'
import { picProcess } from 'meinian-package/src/utils/image'
import Button from 'meinian-package/src/baseComponent/button'
import Space from 'baseComponent/space'
import { useParams } from 'react-router-dom'
import { BatchStart } from 'component'
import Tab from '../component/tab'
import SampleClothingList from '../component/sampleClothingList'
import BtnAddSampleClothing from '../component/btnAddSampleClothing'
import css from './index.module.less'
import FolderListDrawer from '../component/folderListDrawer'
import { useFolder } from '../hooks/useFolder'
import MoreFolderBtn from '../component/moreFolderBtn'
import Breadcrumb, { type Option } from '../component/breadcrumb'
import CustomizeHeader from '../../../components/header/customizeHeader'
import { useFolderTree } from '../hooks/useFolderTree'
import { Filter } from '../component/filters'

function useFolderDetail() {
  const { folderId } = useParams()
  return useAxios(
    async (axios) => {
      const res = await axios.get(`/backend-api/zhikuan/mn/sample/folder/get-folder-info?folderId=${folderId}`)
      return res.data
    },
    { refreshDeps: [folderId] }
  )
}
const DEFAULT_PARAMS = {}
export default () => {
  const { folderId } = useParams()
  const { data: info, refresh } = useFolderDetail()
  const folderParams = { parentId: folderId }
  const { data: children, refresh: refreshFolderChildren } = useFolder(folderParams)
  // 查询面板参数
  const [queryParams, setQueryParams] = useState(DEFAULT_PARAMS)
  // 默认参数Tab（切换Tab时会变化）参数
  const [tab, setTab] = useState('all')
  const [clothingTotal, setClothingTotal] = useState()
  const params = useMemo(() => ({ ...queryParams, queryType: tab, sampleFolderId: folderId }), [queryParams, tab, folderId])
  const $clothingList = useRef(null)
  const [filterVisible, setFilterVisible] = useState(false)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [isBatchMode, setIsBatchMode] = useState(false)
  const { tree, refresh: refreshFolderTree } = useFolderTree()

  const refreshFolders = () => {
    refreshFolderTree()
    refreshFolderChildren()
    refresh()
  }
  const onClothingListLoaded = (total) => {
    setClothingTotal(total)
  }
  const options = useMemo(
    () => [
      { label: '全部样衣', value: 'all', count: tab === 'all' ? clothingTotal : undefined },
      { label: '我新建的', value: 'mine', count: tab === 'mine' ? clothingTotal : undefined },
      { label: '我可操作的', value: 'operable', count: tab === 'operable' ? clothingTotal : undefined },
    ],
    [clothingTotal, tab]
  )

  return (
    <>
      <CustomizeHeader
        style={{ zIndex: 100 }}
        hiddenSearch
        renderLeft={() => (
          <div className="mn-idea-mass-detail-header-left">
            <Breadcrumb options={tree as Option[]} />
          </div>
        )}
      />
      <main className={css.container}>
        <FolderListDrawer
          visible={drawerVisible}
          data={children?.resultList}
          totalCount={children?.resultCount}
          onInit={() => {
            refreshFolders()
            $clothingList.current?.refresh()
          }}
          onClose={() => setDrawerVisible(false)}
          onUpdate={refreshFolders}
          query={undefined}
          info={info}
        />
        <header className={css.header}>
          <div className={css.titleContainer}>
            <span className={css.title}>{info?.folderName}</span>
            <span className={css.btnGroups}>
              <Space size={16}>
                <MoreFolderBtn
                  data={info}
                  onDataChange={refreshFolders}
                  onUpdate={refreshFolders}
                  parent={undefined}
                  tree={tree}
                />
                <Button onClick={() => setDrawerVisible(true)}>子文件夹</Button>
                <BtnAddSampleClothing onClick={() => $clothingList.current?.refresh()} />
              </Space>
            </span>
          </div>
          <div className={css.container}>
            <img src={picProcess(info?.avatar)} alt="" className={css.avatar} />
            <span className={css.username}>{info?.userName}</span>
          </div>
          <div
            style={{
              boxShadow: 'inset 0px 1px 0px 0px var(--m-fill-3)',
            }}
          >
            <Tab
              style={{ padding: '0 24px' }}
              options={options}
              onChange={(val) => {
                setIsBatchMode(false)
                setTab(val)
              }}
              value={tab}
              right={
                <Space size={16}>
                  <Filter
                    visible={filterVisible && !isBatchMode}
                    onVisibleChange={(visible) => {
                      setFilterVisible(visible)
                      if (visible) {
                        setIsBatchMode(false)
                      }
                    }}
                    defaultParams={DEFAULT_PARAMS}
                    value={queryParams}
                    onChange={(_params) => {
                      setQueryParams(_params)
                    }}
                    onCancel={() => setFilterVisible(false)}
                  />
                  <BatchStart
                    displayTextClassName="fill-grey-bg"
                    onClick={() => {
                      setIsBatchMode(true)
                      setFilterVisible(false)
                    }}
                  />
                </Space>
              }
            />
          </div>
        </header>
        <div style={{ position: 'relative', marginTop: '24px' }}>
          <SampleClothingList
            style={{ marginTop: `${isBatchMode && !filterVisible ? '24px' : 0}` }}
            ref={$clothingList}
            setIsBatch={setIsBatchMode}
            isBatch={isBatchMode && !filterVisible}
            onLoaded={onClothingListLoaded}
            params={params}
          />
        </div>
      </main>
    </>
  )
}
